import { withProps } from 'recompose';
import { CustomQuery } from '-/gql/utils';

export default withProps({
    resultKey: 'Person'
})(CustomQuery);
